import { useMediaAdCampaignUpdateMutation } from '@shared/api/graphql/generated';
import type { AdCampaignType } from './useAdCampaign';
import { serializeAdCampaignSettings } from '../lib/serializeAdCampaignSettings';

export const useAdCampaignSave = () => {
  const [mutate, result] = useMediaAdCampaignUpdateMutation();
  const save = async (campaign: AdCampaignType, includePoints: boolean, pointIds?: readonly string[]) => {
    const response = await mutate({
      variables: { input: serializeAdCampaignSettings(campaign, includePoints, pointIds) },
    });
    return response.data?.result?.ok === true && !response.errors?.length;
  };
  return { save, isLoading: result.loading };
};
